import { useContext } from 'react';
import useHeaderAccountModal from '@/SearchResults/useHeaderAccountModal';
import FavoritesContext from '~/contexts/FavoritesContext';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import UserContext, { useUserData } from '~/contexts/UserContext';

const withHandleFavorite = FavoriteComponent => {
  return props => {
    const { isLoggedIn } = useUserData();
    const { tileData } = useTileDataContext();
    const { addFavorite, removeFavorite, setModalVehicleId } =
      useContext(FavoritesContext);
    const { setWipNotificationModalOpen } = useContext(ModalContext);
    const { triggerFetchUserProfile } = useContext(UserContext);
    const {
      vehicleId = 0,
      isFavorite: hasBeenFavorited = false,
      isOnDemand: showWIPNotification = false
    } = tileData;

    const displayWIPModal = () => setWipNotificationModalOpen(true);

    const successHandler = async () => {
      triggerFetchUserProfile();
      if (showWIPNotification) {
        displayWIPModal();
      } else {
        addFavorite({ vehicleId });
      }
    };

    const promptSignIn = useHeaderAccountModal({
      headerModalTitle: 'SAVE TO FAVORITES',
      callerIdentifier: 'Favorites',
      successHandler
    });

    const actionRequired = () => {
      switch (true) {
        case !isLoggedIn:
          return promptSignIn();
        case hasBeenFavorited:
          return removeFavorite({
            vehicleId
          });
        case showWIPNotification:
          return displayWIPModal();
        default:
          return addFavorite({ vehicleId });
      }
    };

    const handleFavorite = () => {
      setModalVehicleId(vehicleId);
      actionRequired();
    };

    return <FavoriteComponent handleFavorite={handleFavorite} {...props} />;
  };
};

export default withHandleFavorite;
